import { useNavigate } from "react-router-dom"
import {useSelector} from 'react-redux';
import Selector from '../../selectors/components/header';

export default ({title}) => {
    const navigate = useNavigate(),
          {wallet} = useSelector(Selector);

    return (
        <div className="header_page">
            <div className="back" onClick={() => navigate('/')}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.2499 14.9401L6.35988 10.0501C5.78238 9.47256 5.78238 8.52756 6.35988 7.95006L11.2499 3.06006" stroke="#DFDFEC" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div className="title">
                {title}
            </div>
            <div className="profile">
                <img src={`../../images/projects/${wallet.project}.jpg`} />
            </div>
        </div> 
    )
}